import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Combobox from 'views_shared/app/javascript/components/Combobox';

import ChipToggle from '../ChipToggle';

function PostsFilter({
 label, value, posts, onChange, onOpen = null, loading = false,
}) {
  const [pendingValue, setPendingValue] = useState(value);
  const [show, setShow] = useState(false);

  const handleToggle = (isOpen) => {
    setShow(isOpen);
    if (isOpen) {
      setPendingValue(value);
      onOpen?.(); // options load on first open, not on inbox mount
    }
  };

  const handleApply = () => {
    onChange(pendingValue);
    setShow(false);
  };

  const hasChanged = pendingValue !== value;

  // The full-title tooltip lives on the option ROW (Combobox sets it from option.label), so
  // hovering anywhere in the row works — not just over the text.
  // minWidth:0 — a flex item will not shrink below its content width without it, so
  // text-truncate alone would let long titles overflow instead of clipping.
  const renderPostOption = (option) => (
    <>
      <i className="fa-solid fa-megaphone text-primary-60 mt-1 flex-shrink-0" />
      <span className="text-truncate" style={{ minWidth: 0 }}>
        {option.label}
      </span>
    </>
  );

  return (
    <Dropdown show={show} onToggle={handleToggle}>
      <Dropdown.Toggle as={ChipToggle}>
        {label}
        <i className="fa-solid fa-chevron-down paragraph-sm fw-normal" />
      </Dropdown.Toggle>

      {/* Fixed width, not min/max: the menu is right-anchored, so letting it grow to fit a
          request title pushed its left edge off-screen (measured at x=-65, and at 1087px wide
          before the options truncated). A fixed box keeps it anchored and lets titles clip. */}
      <Dropdown.Menu className="px-3 py-3" style={{ width: '320px', maxWidth: 'calc(100vw - 32px)' }}>
        <p className="paragraph-md fw-bold mb-3">Title</p>

        <Combobox
          value={pendingValue}
          options={posts}
          placeholder={loading ? 'Loading…' : 'Select post'}
          emptyText={loading ? 'Loading…' : undefined}
          disabled={loading}
          onChange={setPendingValue}
          renderOption={renderPostOption}
          title={posts.find((o) => String(o.value) === String(pendingValue))?.label}
        />

        <button type="button" className="btn btn-primary w-100 mt-2 py-1" disabled={!hasChanged} onClick={handleApply}>
          Apply
        </button>
      </Dropdown.Menu>
    </Dropdown>
  );
}

PostsFilter.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  loading: PropTypes.bool,
};

export default PostsFilter;
